<template>
  <div class="re-el-form__flex">
    <div class="medium">
      <el-form-item :label="title">
        <el-button size="middle"
                   v-if="!uploaded"
                   :disabled="disabled"
                   @click="$refs.uploadMarketModal.open()">点击上传
        </el-button>
        <div style="line-height: 36px"
             v-else>
          <sj-progress :stroke-width="18"
                       :status="taskBatchStatus(batchjob)"
                       :text-inside="true"
                       :percentages="taskBatchPercentage(batchjob)"></sj-progress>
          <div style="display: flex;justify-content: space-between">
            <div>成功:{{batchjob.success_count}} 错误: {{batchjob.error_count}}</div>
            <div v-if="batchjob.error_count > 0 && batchjob.status === 3">
              <el-button type="text"
                         @click="onDownErrorFile(batchjob.id)">下载错误行
              </el-button>
              <el-button type="text"
                         @click="reUploadFile(batchjob.id)">重新上传
              </el-button>
            </div>
          </div>
        </div>
      </el-form-item>

      <sj-upload-modal request="createTaskBatch"
                       :request-data="requestData"
                       ref="uploadMarketModal"
                       file-extension="xlsx"
                       :show-clear-btn="false"
                       @uploaded="onUploadedMarketSalaryFile"
                       :validate-file="true">
      </sj-upload-modal>
    </div>
  </div>
</template>

<script>
import SjUploadModal from '@components/sj-upload-modal/SjUploadModal'
import SjProgress from '@components/sj-progress/SjProgress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'

export default {
  mixins: [taskBatchMixins],
  components: {SjUploadModal, SjProgress},
  inject: ['taskForm', 'page'],
  computed: {
    typeOption () {
      return this.typeOptions.find(el => el.type === this.page.form.taskAreaType)
    },
    title () {
      if (this.typeOption) {
        return this.typeOption.title
      } else {
        return ''
      }
    },
    disabled () {
      const form = this.page.form
      if (this.page.form.taskAreaType === 2) {
        if (form.estimate_consume_mins && form.projectid && form.hirenum) {
          return false
        }
      }
      if ([3, 4].includes(this.page.form.taskAreaType)) {
        if (form.estimate_consume_mins && form.projectid) {
          return false
        }
      }
      return true
    },
    requestData () {
      let type
      if (this.typeOption) {
        type = this.typeOption.requestType
      }
      return {
        type: type,
        file_type: 1,
        collection_type: 10,
        params: {
          task_type: this.taskForm.form.type
        }
      }
    },
  },
  data () {
    return {
      uploaded: false,
      batchjob: {
        id: null,
        status: 1,
        error_count: 0,
        total_count: 0,
        success_count: 0,
      },
      interval: null,
      typeOptions: [
        {type: 2, title: '上传门店', requestType: 247, uploaded: this.handleUploadedMiddleEndTaskResults},
        {type: 3, title: '上传定向用户', requestType: 253, uploaded: this.handleUploadedNationalTaskResults},
        {type: 4, title: '上传城市', requestType: 251, uploaded: this.handleUploadedMiddleEndTaskResults}]
    }
  },
  methods: {
    onUploadedMarketSalaryFile (result) {
      if (result) {
        this.uploaded = true
        this.interval = setInterval(() => {
          request.alert('getMiddleEndTaskBatchjob', {id: result.id}).then(({data}) => {
            this.$set(this, 'batchjob', data)
            if (data.status * 1 === -2) {
              clearInterval(this.interval)
              this.$message.error(data.error_message)
              this.uploaded = false
            }
            if (data.status * 1 === 3) {
              clearInterval(this.interval)
              this.typeOption.uploaded.call(this, data)
            }
          })
        }, 3000)
      }
    },
    handleUploadedMiddleEndTaskResults (data) {
      this.taskForm.enableCitySalaryTable(true)

      let result = data.params.result
      let cityTable = []
      for (let key in result) {
        if (result.hasOwnProperty(key)) {
          cityTable.push({cityid: key, ...result[key]})
        }
      }

      this.taskForm.setCityTable(cityTable)
      this.taskForm.setSourceData(data.params['source_data'])

      if (data.error_count) {
        this.$confirm(this.title + '存在错误，请选择下一步操作。', '任务配置', {
          type: 'warning',
          distinguishCancelAndClose: true,
          confirmButtonText: '前往定价页',
          cancelButtonText: '下载错误行'
        }).then(() => {
          this.taskForm.switchTab('second')
        }).catch(action => {
          if (action === 'cancel') {
            this.onDownErrorFile(data.id)
          }
        })
      } else {
        this.$confirm(this.title + '成功，请选择下一步操作', '任务配置', {
          type: 'warning',
          cancelButtonText: '留在当前页',
          confirmButtonText: '前往定价页'
        }).then(() => {
          this.taskForm.switchTab('second')
        })
      }
    },
    handleUploadedNationalTaskResults (data) {
      if (data.error_count) {
        this.$confirm(this.title + '存在错误，请选择下一步操作。', '任务配置', {
          type: 'warning',
          distinguishCancelAndClose: true,
          confirmButtonText: '继续操作',
          cancelButtonText: '下载错误行'
        }).then(() => {
          this.taskForm.confirmNationalTask(data.params)
        }).catch(action => {
          if (action === 'cancel') {
            this.onDownErrorFile(data.id)
          }
        })
      } else {
        this.taskForm.confirmNationalTask(data.params)
      }
    },
    reload () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    reUploadFile () {
      this.$confirm('确定要重新上传吗？', '任务配置', {
        type: 'warning',
      }).then(() => {
        this.reload()
        this.taskForm.enableCitySalaryTable(false)
        this.$refs.uploadMarketModal.open()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/middle-end-task/components/MarketsFormItem.vue